import { render } from "./WelcomeBack.vue?vue&type=template&id=49a57e8e"
import script from "./WelcomeBack.vue?vue&type=script&lang=js"
export * from "./WelcomeBack.vue?vue&type=script&lang=js"

import "./WelcomeBack.vue?vue&type=style&index=0&id=49a57e8e&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__